<template>
  <!-- 代理记账 -->
  <div id="agency">
    <div class="agency-img">
      <img src="./images/组 2860.png" alt />
    </div>
    <!-- 代理记账选择 -->
    <div class="charge-module">
      <book-keeping></book-keeping>
    </div>
    <!-- 代理记账流程 -->
    <div class="process">
      <div class="process-miden">
        <div class="process-title">
          <h2>代理记账服务流程</h2>
        </div>
        <div class="process-cont">
          <div class="process-img-bg">
            <img src="./images/路径 2746.png" alt />
          </div>
          <!-- items -->
          <!-- <div class="process-items"> -->
          <div class="child-item item1">
            <h3>签订服务合同</h3>
            <img src="./images/组 2870.png" alt />
          </div>
          <div class="child-item item2">
            <h3>交接代账资料</h3>
            <img src="./images/组 2871.png" alt />
          </div>
          <div class="child-item item3">
            <h3>专属会计做账</h3>
            <img src="./images/组 2872.png" alt />
          </div>
          <div class="child-item item4">
            <h3>社保税金确认</h3>
            <img src="./images/组 2895.png" alt />
          </div>
          <div class="child-item item5">
            <img src="./images/组 2873.png" alt />
            <h3>按期纳税申报</h3>
          </div>
          <div class="child-item item6">
            <img src="./images/组 2874.png" alt />
            <h3>报表在线查看</h3>
          </div>
          <div class="child-item item7">
            <img src="./images/组 2875.png" alt />
            <h3>售后税务咨询</h3>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <!-- 代理记账服务内容 -->
    <div class="service-content">
      <div class="service-middle">
        <h2 class="service-middle-h2">代理记账服务内容</h2>
        <div class="service-middle-flex">
          <div>
            <img class="middle-flex" src="./images/组 2879.png" alt />
            <div class="middle-left">
              <div class="text-cont">
                <div>1.营业执照副本复印件</div>
                <div>2、法人及股东身份证复印件</div>
                <div>3、税务申报用户名和密码</div>
                <div>4、社保人员名单及身份证复印件</div>
                <div>5、非新注册公司交接原会计资料</div>
              </div>
              <div class="left-bottom">
                <img src="./images/组 2773.png" alt />
              </div>
            </div>
          </div>
          <div>
            <img class="middle-flex" src="./images/组 2880.png" alt />
            <div class="middle-middle">
              <div class="text-cont">
                <div>
                  1、征期内按时完成财务记账
                  <br>
                  <br />整理收入、成本、费用发票及银行回单进行详细归类、核对
                  <br>
                  <br />核对税务系统数据与客户提供的发票等资料，编制凭证及报表
                </div>
                <div class="cont-2">
                  2、征期内按时完成纳税申报
                  <br>
                  <br />申报地方税种：个人所得税，地方附加税，残疾人保障金，工会经费，社保
                  <br>
                  <br />申报增值税主表及各类附表，申报财务报表
                  <br>
                  <br />提前告知应交税金，待确认后全申报点扣款
                  <br>
                  <br />一季度申报一次企业所得税
                </div>
                <div>3、每月一次打印凭证及装订，每年一次打印总账及明细账</div>
              </div>
              <div class="left-bottom">
                <img src="./images/组 2774.png" alt />
              </div>
            </div>
          </div>
          <div>
            <img class="middle-flex" src="./images/组 2881.png" alt />
            <div class="middle-right middle-left">
              <div class="text-cont">
                <div>1、免费办理年度所得税汇算清缴</div>
                <div>2、免费企业工商年检申报工作</div>
                <div>3、新注册公司免费核定税种</div>
                <div>4、协助税企沟通，通知最新政策</div>
                <div>5、提供基础类的税收合规安排</div>
              </div>
              <div class="left-bottom">
                <img src="./images/组 2775.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 成功案例 -->
    <div class="collaborate-friend">
      <div class="friend-content">
        <div class="content-h2">
          <h2>成功案例</h2>
        </div>
        <div class="content-imgs">
          <img src="./images/组 2882.png" alt />
          <img src="./images/组 2883.png" alt />
          <img src="./images/组 2884.png" alt />
          <img src="./images/组 2885.png" alt />
          <img src="./images/组 2886.png" alt />
          <img src="./images/组 2887.png" alt />
          <img src="./images/组 2888.png" alt />
          <img src="./images/组 2889.png" alt />
          <img src="./images/组 2890.png" alt />
          <img src="./images/组 2891.png" alt />
          <img src="./images/组 2893.png" alt />
          <img src="./images/组 2894.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BookKeeping from "@/common/book-keeping";
export default {
  name: "agency",
  data() {
    return {};
  },
  components: {
    BookKeeping
  }
};
</script>

<style lang="scss" scoped>
.agency-img {
  width: 100%;
  min-width: 1040px;
  img {
    width: 100%;
  }
}
.charge-module {
  width: 1040px;
  margin: 0 auto;
  // padding: 0 7%;
  box-sizing: border-box;
}
.process {
  width: 100%;
  min-width: 1040px;
  display: flex;
  justify-content: center;
  padding-bottom: 50px;
  padding-top: 50px;
  background: rgb(245, 245, 245);
  .process-miden {
    width: 850px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .process-title {
      font-weight: 900;
      padding-bottom: 40px;
    }
    .process-cont {
      position: relative;
      margin: 80px 0;
      .process-img-bg {
        position: relative;
        top: 0;
        left: 0;
        img {
          width: 100%;
        }
      }

      .child-item {
        width: 14%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        img {
          width: 60%;
        }
      }
      .item1 {
        position: absolute;
        top: -71px;
        left: -25px;
        h3 {
          margin-bottom: 20px;
        }
      }
      .item2 {
        position: absolute;
        top: -71px;
        left: 26%;
        h3 {
          margin-bottom: 20px;
        }
      }
      .item3 {
        position: absolute;
        top: -71px;
        left: 55%;
        h3 {
          margin-bottom: 20px;
        }
      }
      .item4 {
        position: absolute;
        top: -71px;
        right: 10px;
        h3 {
          margin-bottom: 20px;
        }
      }
      .item5 {
        position: absolute;
        bottom: -71px;
        right: 14%;
        h3 {
          margin-top: 20px;
        }
      }
      .item6 {
        position: absolute;
        bottom: -71px;
        right: 45%;
        h3 {
          margin-top: 20px;
        }
      }
      .item7 {
        position: absolute;
        bottom: -71px;
        left: 12%;
        h3 {
          margin-top: 20px;
        }
      }

      /* // .process-items > div:nth-child(2n) {
      //   align-self: flex-end;
      // } */
    }
  }
}
.service-content {
  width: 100%;
  min-width: 1040px;
  display: flex;
  justify-content: center;
  padding-bottom: 50px;
  .service-middle {
    width: 1040px;
    .service-middle-h2 {
      margin: 40px 0;
    }
    .service-middle-flex {
      display: flex;
      border-bottom: 1px solid rgb(238, 238, 238);
      .middle-flex {
        width: 100%;
      }
      .middle-left {
        border-right: 1px solid rgb(238, 238, 238);
        border-left: 1px solid rgb(238, 238, 238);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 20px;
        .left-bottom {
          width: 100%;
          padding: 30px 0;
          border-top: 1px dotted rgb(238, 238, 238);
          display: flex;
          justify-content: center;
          img {
            width: 50%;
          }
        }
        .text-cont {
          height: 440px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          div {
            width: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top: 1px dotted #ccc;
            text-align: center;
          }
        }
        .text-cont div:nth-child(1) {
          border: 0;
        }
      }
      .middle-middle {
        padding: 0 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .left-bottom {
          width: 100%;
          padding: 30px 0;
          border-top: 1px dotted #ccc;
          display: flex;
          justify-content: center;
          img {
            width: 50%;
          }
        }
        .text-cont {
          height: 440px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          div {
            width: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top: 1px dotted #ccc;
            text-align: center;
            padding: 10px 0;
          }
          .cont-2 {
            flex: 1.3;
          }
        }
        .text-cont div:nth-child(1) {
          border: 0;
        }
      }
    }
    .service-middle-flex > div {
      flex: 1;
    }
  }
}

.collaborate-friend {
  background: rgb(245, 245, 245);
  width: 100%;
  min-width: 1040px;
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 40px 0;
  .friend-content {
    width: 1040px;
    margin: 0 auto;
    box-sizing: border-box;
    .content-h2 {
      margin-bottom: 30px;
    }
    .content-imgs {
      img {
        width: 16%;
        margin-bottom: 4px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/agency/agency.vue